import { useEffect } from 'react';
import { useDispatch } from '@witmetrics/data-store';
import { useToggle } from '@/hooks/useToggle';
import { useAppState } from '@/providers/AppStateProvider';
import { fetchFileData } from '@/utils/files';
import Overlay from '@/components/Overlay';
import FileViewer from '@/components/viewers/FileViewer';
import { classes, useTimelineSettings } from './utils';

export type FileOverlayProps = {
  fileId: number;
  onClose: () => void;
};

export default function FileOverlay({ fileId, onClose }: FileOverlayProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const [isTimelineOpen, toggleTimeline] = useTimelineSettings(false);
  const [isFetchingData, toggleFetchingData] = useToggle(true);

  useEffect(() => {
    fetchData();
  }, [fileId]);

  const fetchData = async () => {
    try {
      toggleFetchingData(true);
      const data = await fetchFileData(fileId);
      dispatch.addFiles([data.file]);
      if (data.fileVersion) dispatch.addFileVersions([data.fileVersion]);
      dispatch.addFileNotes(data.fileNotes);
      toggleFetchingData(false);
    } catch (err) {
      onApiError(err, 'Error fetching file data', () => fetchData());
    }
  };

  return (
    <Overlay className={classes.overlay} variant="glass" onClose={onClose}>
      <FileViewer
        showTimeline={isTimelineOpen}
        className={classes.viewer}
        fileId={fileId}
        onToggleTimeline={toggleTimeline}
        onClose={onClose}
      />
    </Overlay>
  );
}
